module.exports = __webpack_public_path__ + "static/enbw-ref-img-6dcd559d8e1924e76b7d60891128b51a.png";